<template>
  <div>
    <vs-card class="cstm_vx_card">
      <vs-row vs-justify="space-between" slot="header">
        <h4>Phone</h4>
        <vs-button
         v-if="checkEditPermission()"
          type="border"
          color="primary"
          style="font-size: 13.8px; padding: 7px; float: right;"
          @click="phoneNumberAddpopup  = true"
        >
          Add
        </vs-button>
      </vs-row>


      <div class="vx-row">
        <vs-table :data="phoneAvailability" class="cstm_vuexy_table w-full">
          <template slot="thead">
            <vs-th sort-key="name">Phone</vs-th>
            <vs-th sort-key="status" style="width: 250px;">Action</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(item, indextr) in data">
              <vs-td :data="data[indextr].phone">
                {{ data[indextr].phone }}
              </vs-td>
              <vs-td :data="data[indextr]">
                <vs-row vs-type="flex">
                  <vs-checkbox v-model="data[indextr].default" @change="handlePhonedefault(indextr)">Mark Default</vs-checkbox>
                  <vs-button color="primary" v-if="checkEditPermission()" type="filled" icon="edit" class="mr-2" @click="handleeditphone(indextr)"/>
                  <vs-button radius v-if="checkDeletePermission()" :disabled ="data[indextr].default === 1" @click="handledeleteAndPopup(indextr)" icon="delete" color="danger"/>
                </vs-row>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vs-card>


    <vs-popup classContent="popup-example"  title="Delete" :active.sync="phoneDeletepupup">
      <h4>Are you sure to delete this ?</h4>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click="handleDeletePhone()">Confirm</vs-button>
        <vs-button type="border" color="danger" @click="phoneDeletepupup = false">Cancel</vs-button>
      </vs-row>
    </vs-popup>


    <vs-popup classContent="popup-example"  title="Add Phone" :active.sync="phoneNumberAddpopup">
      <form data-vv-scope="add">
        <vs-row>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
              <vs-input v-validate="'required|numeric'" name="phone" v-model="phoneNumber" class="custom_Input" label="Phone number" icon-pack="feather" icon="icon-edit" icon-after style="width:100%;" />
            <span v-show="errors.has('add.phone')" class="text-danger">{{ errors.first('add.phone') }}</span>
          </vs-col>
        </vs-row>
      </form>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click.prevent="handleSavePhoneNumber">Save</vs-button>
        <vs-button type="border" color="danger" @click="phoneNumberAddpopup  = false">Cancel</vs-button>
      </vs-row>
    </vs-popup>


    <vs-popup classContent="popup-example"  title="Edit Phone" :active.sync="phoneeditpopup">
      <form data-vv-scope="edit">
        <vs-row>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
              <vs-input v-validate="'required'" name="phone" v-model="editphone" class="custom_Input" label="Phone number" icon-pack="feather" icon="icon-edit" icon-after style="width:100%;" />
              <span v-show="errors.has('edit.phone')" class="text-danger">{{ errors.first('edit.phone') }}</span>
          </vs-col>
        </vs-row>
      </form>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click.prevent="handleUpdatePhone">Save</vs-button>
        <vs-button type="border" color="danger" @click="phoneeditpopup = false">Cancel</vs-button>
      </vs-row>
    </vs-popup>
  </div>
</template>
<script>
import {  TeacherUpdate } from '@/api/teacher'
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'

export default {
  name: 'phone',
  props: {
    phoneProps:{
      required: true,
      type: Array,
      default: () => []
    }
  },      
  created () {
    const role_permission = localStorage.getItem('role_permission')
    if (role_permission == 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.getModulePermission('Teachers')
    }
  },
  mixins: [PermissionMiddleware],
  data () {
    return {
      phoneNumberAddpopup: false,
      phoneDeletepupup: false,
      deleteIndex: null,
      phoneeditpopup: false,
      editphone: null,
      editindex: null,
      phoneNumber:null,
      phoneAvailability:[]

    }
  },
  watch:{
    phoneProps:{
      deep:true,
      immediate:true,
      handler () {
        this.phoneAvailability = this._.cloneDeep(this.phoneProps)
      }
    }
  },
  /* computed: {
    phoneAvailability: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }, */
  methods: {
    handlePhonedefault (index) {
      this.phoneAvailability.map(item => {
        item.default = 0
      })
      this.phoneAvailability[index].default = 1
      this.editindex  = index
      this.editphone = this.phoneAvailability[index].phone
      this.handleUpdatePhone()
    },
    handleDeletePhone () {
      this.phoneAvailability.splice(this.deleteIndex, 1)
      this.handlePhonesave()

    },
    handledeleteAndPopup (index) {
      this.phoneDeletepupup = true
      this.deleteIndex = index
    },
    handleeditphone (index) {
      this.editphone = this.phoneAvailability[index].phone
      this.phoneeditpopup = true
      this.editindex  = index
      // this.handlePhonesave()
    },
    handleUpdatePhone () {
      this.$validator.validateAll('edit').then(result => {
        if (result) {
          this.phoneAvailability[this.editindex].phone = this.editphone
          this.handlePhonesave()
        }
      })
    },
    handleSavePhoneNumber () {
      this.$validator.validateAll('add').then(result => {
        if (result) {
          const payload = {
            phone: this.phoneNumber,
            default: 0
          }
          this.phoneAvailability.push(payload)
         
          this.handlePhonesave()
        }
      })

    },
    async handlePhonesave () {
      try {
        const customer_id = localStorage.getItem('customer_id')
        const payload = {
          updateField: {
            phone: this.phoneAvailability
          }
        }
        const {data} = await TeacherUpdate(
          payload,
          this.$route.params.teacher_id,
          customer_id
        )
        // this.setAfterUpdate(data)
        this.phoneNumber = null
        this.phoneNumberAddpopup = false
        this.phoneDeletepupup = false
          this.phoneeditpopup  = false


        this.$emit('setAfterUpdate', data)
        // this.fetchTeacherDetails(this.$route.params.teacher_id)
        // this.bioEditPopup = false
        this.showSuccessMessage('Success', 'Updated Successfully', 'success')

      } catch (error) {
        console.log(error)
        this.showSuccessMessage('Error', error.data.message, 'danger')
      }
    }
  }
}
</script>
